import { render, staticRenderFns } from "./BoardWriteDonateLayout.vue?vue&type=template&id=5321eae2&scoped=true&"
import script from "./BoardWriteDonateLayout.vue?vue&type=script&lang=js&"
export * from "./BoardWriteDonateLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5321eae2",
  null
  
)

export default component.exports